module.exports = __webpack_public_path__ + "static/media/slider-3.c7532381.jpg";